// @flow
/* eslint-disable react/no-danger */
import React from 'react';

const icon = {
    __html: `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
        <g fill="none">
            <g style="stroke-width:2;stroke:#353E44">
              <path d="M1.4 1.4L13.7 13.7"/>
              <path d="M14 2L2 14"/>
            </g>
        </g>
    </svg>
`
};

export const IconClose = () => <span dangerouslySetInnerHTML={icon} />;

export default IconClose;
